// import React from "react";

// const vehicles = [
//   {
//     id: 1,
//     name: "Hyundai Aura",
//     image: "/images/fleets/Hyundai-Aura.jpg",
//     desc: "Comfortable 4-seater sedan ideal for airport transfers, local travel, and business trips.",
//   },
//   {
//     id: 2,
//     name: "Maruti Suzuki Ertiga",
//     image: "/images/fleets/Maruti-Suzuki-Ertiga.jpg",
//     desc: "Spacious 6-7 seater MPV perfect for family outings and outstation journeys.",
//   },
//   {
//     id: 3,
//     name: "Force Urbania",
//     image: "/images/fleets/Force-Urbania.jpg",
//     desc: "Luxury 13-seater vehicle offering premium comfort for group tours and corporate travel.",
//   },
//   {
//     id: 4,
//     name: "17 Seater Tempo Traveller",
//     image: "/images/fleets/17-Seater-Tempo-Traveller.jpg",
//     desc: "Ideal for family vacations, pilgrimages, and small group tours.",
//   },
//   {
//     id: 5,
//     name: "20 Seater Tempo Traveller",
//     image: "/images/fleets/20-Seater-Tempo-Traveller.jpg",
//     desc: "Comfortable travel solution for medium-sized groups and corporate outings.",
//   },
//   {
//     id: 6,
//     name: "32 Seater Bus",
//     image: "/images/fleets/32-Seater-Bus.jpg",
//     desc: "Reliable bus rental for school trips, weddings, and corporate transportation.",
//   },
//   {
//     id: 7,
//     name: "35 Seater Bus",
//     image: "/images/fleets/35-Seater-Bus.jpg",
//     desc: "Spacious and comfortable bus suitable for group tours and events.",
//   },
//   {
//     id: 8,
//     name: "40 Seater Bus",
//     image: "/images/fleets/40-Seater-Bus.jpg",
//     desc: "Perfect for large family gatherings, corporate events, and educational tours.",
//   },
//   {
//     id: 9,
//     name: "45 Seater AC Bus",
//     image: "/images/fleets/45-Seater-AC-Bus.jpg",
//     desc: "Premium air-conditioned bus offering comfortable long-distance group travel.",
//   },
// ];

// const OurFleets = () => {
//   return (
//     <>



//        <div className="page-headder bg-section parallaxie">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="page-header-box text-white">
//                 <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
//                   Our Fleets
//                 </h1>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

    
//     <div className="section-full py-3 fleet-wrap">
//       <div className="container">

       

//         {/* Grid */}
//         <div className="row">

//           {vehicles.map((item) => (
//             <div key={item.id} className="col-lg-4 col-md-4 col-sm-6 mb-4">

//               <div className="fleet-card">

//                 <div className="fleet-img">
//                   <img src={item.image} alt={item.name} />
//                 </div>

//                 <div className="fleet-content">
//                   <h4 className="darkcolorrrr">{item.name}</h4>
//                   <p>{item.desc}</p>
//                 </div>

//               </div>

//             </div>
//           ))}

//         </div>

//       </div>

//       {/* Styling */}
//       <style jsx>{`
//         .fleet-wrap {
//           background: linear-gradient(135deg, #fff7ed, #fef3e2);
//         }

//         .fleet-card {
//           background: #fff;
//           border-radius: 12px;
//           overflow: hidden;
//           border: 1px solid #f3d6b3;
//           box-shadow: 0 6px 18px rgba(90, 45, 12, 0.12);
//           transition: 0.3s;
//           height: 100%;
//         }

//         .fleet-card:hover {
//           transform: translateY(-6px);
//         }

//         .fleet-img img {
//           width: 100%;
//         //   height: 200px;
//           object-fit: cover;
//         }

//         .fleet-content {
//           padding: 15px;
//           text-align: center;
//         }

//         .fleet-content h4 {
//           color: #5a2d0c;
//           margin-bottom: 8px;
//         }

//         .fleet-content p {
//           color: #8b5e3c;
//           font-size: 14px;
//           margin: 0;
//         }
//       `}</style>
//     </div>
//     </>
//   );
// };

// export default OurFleets;














import React from "react";

const vehicles = [
  // =====================
  // TEMPO TRAVELLER FIRST
  // =====================
 
   {
    id: 3,
    name: "Force Urbania",
    image: "/images/fleets/Force-Urbania.jpg",
    desc: "Luxury 13-seater premium vehicle for corporate and group travel.",
    seats: "13 Seater",
    bags: "10-12 Bags",
  },
  {
    id: 4,
    name: "17 Seater Tempo Traveller",
    image: "/images/fleets/17-Seater-Tempo-Traveller.jpg",
    desc: "Ideal for family vacations, pilgrimage tours, weddings, and group travel with comfort.",
    seats: "17 Seater",
    bags: "14-16 Bags",
  },
  {
    id: 5,
    name: "20 Seater Tempo Traveller",
    image: "/images/fleets/20-Seater-Tempo-Traveller.jpg",
    desc: "Spacious and comfortable Tempo Traveller for medium-sized group journeys and tours.",
    seats: "20 Seater",
    bags: "18-20 Bags",
  },

  

  // =====================
  // BUSES NEXT
  // =====================
  {
    id: 6,
    name: "32 Seater Bus",
    image: "/images/fleets/32-Seater-Bus.jpg",
    desc: "Reliable bus for school trips, corporate travel, and group transportation needs.",
    seats: "32 Seater",
    bags: "25+ Bags",
  },
  {
    id: 7,
    name: "35 Seater Bus",
    image: "/images/fleets/35-Seater-Bus.jpg",
    desc: "Spacious bus ideal for group tours, weddings, and event transportation.",
    seats: "35 Seater",
    bags: "30+ Bags",
  },
  {
    id: 8,
    name: "40 Seater Bus",
    image: "/images/fleets/40-Seater-Bus.jpg",
    desc: "Perfect for large family gatherings, corporate tours, and long-distance travel.",
    seats: "40 Seater",
    bags: "35+ Bags",
  },
  {
    id: 9,
    name: "45 Seater AC Bus",
    image: "/images/fleets/45-Seater-AC-Bus.jpg",
    desc: "Premium AC bus designed for long-distance group travel with maximum comfort.",
    seats: "45 Seater",
    bags: "40+ Bags",
  },

  // =====================
  // CARS LAST
  // =====================
  {
    id: 1,
    name: "Hyundai Aura",
    image: "/images/fleets/Hyundai-Aura.jpg",
    desc: "Comfortable sedan ideal for airport transfers and business trips.",
    seats: "4 Seater",
    bags: "2 Bags",
  },
  {
    id: 2,
    name: "Maruti Suzuki Ertiga",
    image: "/images/fleets/Maruti-Suzuki-Ertiga.jpg",
    desc: "Spacious MPV perfect for family outings and outstation journeys.",
    seats: "6-7 Seater",
    bags: "4-5 Bags",
  },

];

const OurFleets = () => {
  return (
    <>
      {/* HEADER */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-center text-white fleet-title">
                  Our Fleets
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* GRID SECTION */}
      <div className="section-full py-4 fleet-wrap">
        <div className="container">
          <div className="row">
            {vehicles.map((item) => (
              <div key={item.id} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                <div className="fleet-card">
                  <div className="fleet-img">
                    <img src={item.image} alt={item.name} />
                  </div>

                  <div className="fleet-content">
                    <h4 className="darkk">{item.name}</h4>
                    <p className="desc">{item.desc}</p>

                    <div className="fleet-info">
                      <span>🚗 {item.seats}</span>
                      <span>🧳 {item.bags}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* STYLES */}
        <style jsx>{`
          .fleet-wrap {
            background: linear-gradient(135deg, #0a0a0a, #1a0000);
            min-height: 100vh;
          }

          .fleet-title {
            font-weight: 700;
            letter-spacing: 1px;
            color: #ff1a1a;
            text-shadow: 0 0 10px rgba(255, 0, 0, 0.4);
          }

          .fleet-card {
            background: #111;
            border-radius: 14px;
            overflow: hidden;
            border: 1px solid #8b0000;
            box-shadow: 0 8px 22px rgba(255, 0, 0, 0.15);
            transition: 0.3s ease;
            height: 100%;
          }

          .fleet-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 12px 30px rgba(255, 0, 0, 0.3);
          }

          .fleet-img img {
            width: 100%;
            height: 200px;
            object-fit: cover;
            transition: 0.3s;
          }

          .fleet-card:hover .fleet-img img {
            transform: scale(1.05);
          }

          .fleet-content {
            padding: 16px;
            text-align: center;
            color: #fff;
          }

          .fleet-content h4 {
            color: #ffb100;
            margin-bottom: 8px;
            font-weight: 600;
          }

          .desc {
            color: #ccc;
            font-size: 14px;
            margin-bottom: 12px;
          }

          .fleet-info {
            display: flex;
            justify-content: space-between;
            background: #1a1a1a;
            padding: 10px;
            border-radius: 8px;
            border: 1px solid #8b0000;
            font-size: 13px;
            color: #ffb100;
            font-weight: 500;
          }
        `}</style>
      </div>
    </>
  );
};

export default OurFleets;